import styled from 'styled-components';
import CandidateSearch from '../CandidateSearch';
import JobSearch from '../JobSearch';

export const AddFilters = styled.button`
  font-size: 14px;
  line-height: 21px;
  color: ${(props) => props.theme.colors['primary-60']};
`;

export const Header = styled.div`
  margin-bottom: 16px;
  z-index: 3;
  position: relative;
  justify-content: space-between;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    margin-top: -10px;
    align-items: center;
  }
`;

export const HeaderRightSide = styled.div`
  margin-top: 32px;
  flex-direction: column;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    margin-top: 0;
    flex-direction: row;
    flex: 1;
    justify-content: flex-end;
  }
`;

export const ActionsArea = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: 8px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 32px;
    justify-content: end;
  }
`;

export const SearchInput = styled(CandidateSearch)`
  width: calc(100% - 48px);
  position: relative;
  z-index: 2;
`;

export const JobSearchInput = styled(JobSearch)`
  width: calc(100% - 48px);
  position: relative;
  z-index: 2;
`;

export const AddNew = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors['tertiary-60']};
  svg {
    fill: #fff;
  }
`;
